import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'bb-table-thumbnail',
	templateUrl: './bb-table-thumbnail.component.html',
	styleUrls: ['./bb-table-thumbnail.component.scss']
})

export class BbTableThumbnailComponent implements OnInit {
	@Input() entity: any;

	ngOnInit() {

	}

}
